import React, { useState, useEffect } from "react";
import Select from "react-select";

const SelectType = ({
  question,
  data,
  onChange,
  disable,
  validationErrors,
  multiple,
  isChild,
}) => {
  const [multipleData, setMultipleData] = useState([]);
  const [singleData, setSingleData] = useState("");

  useEffect(() => {
    if (question.type == "M") {
      if (typeof data == "string") {
        setMultipleData(JSON.parse(data));
      } else {
        setMultipleData(data);
      }
    } else {
      setSingleData(data);
    }
  }, [data]);

  const getOptions = (options) => {
    return options?.map((option, index) => ({
      value: option.id.toString(),
      label: option.value,
    }));
  };

  return (
    <>
      {disable ? (
        <>
          {question.type == "M" ? (
            <>
              {question.options.map(
                (option, index) =>
                  multipleData?.includes(option.id) && (
                    <option key={index} value={option.id}>
                      {option.value}
                    </option>
                  )
              )}
            </>
          ) : (
            <>
              {question.options?.map((option, index) => (
                <React.Fragment key={index}>
                  {option.id == singleData && option.value}
                </React.Fragment>
              ))}
            </>
          )}
        </>
      ) : (
        <>
          {/* <select
            name={question.id}
            value={question.type == "M" ? multipleData || [] : singleData || ""}
            onChange={(e) => {
              onChange(e);
            }}
            className={`form-control ${
              validationErrors[question.id] && "is-invalid"
            }`}
            id={question.id}
            style={{ width: "100%" }}
            disabled={disable}
            multiple={multiple}
          >
            {multiple ? (
              <>
                {question.options.map((option, index) => (
                  <option key={index} value={option.id}>
                    {option.value}
                  </option>
                ))}
              </>
            ) : (
              <>
                {isChild ? (
                  <>
                    <option value="">Select an option...</option>
                    {question.childOptionsVOs?.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.value}
                      </option>
                    ))}
                  </>
                ) : (
                  <>
                    <option value="">Select an option...</option>
                    {question.options?.map((option, index) => (
                      <option key={index} value={option.id}>
                        {option.value}
                      </option>
                    ))}
                  </>
                )}
              </>
            )}
          </select> */}
          <Select
            name={question.id}
            value={
              getOptions(
                multiple
                  ? question.options
                  : isChild
                  ? question.childOptionsVOs
                  : question.options
              ).find(
                (option) =>
                  option.value ===
                  (question.type == "M" ? multipleData || [] : singleData)
              ) || null
            }
            onChange={(selectedOption) => {
              onChange({
                target: { name: question?.id, value: selectedOption?.value },
              });
            }}
            className={`form-control ${
              validationErrors[question.id] && "is-invalid"
            }`}
            id={question.id}
            styles={{
              container: (provided) => ({
                ...provided,
                width: "100%",
                height: "50px",
              }),
            }}
            isDisabled={disable}
            isMulti={multiple}
            placeholder="Select ..."
            isSearchable
            options={getOptions(
              multiple
                ? question.options
                : isChild
                ? question.childOptionsVOs
                : question.options
            )}
          />

          {validationErrors[question.id] && (
            <div className="invalid-feedback">
              {validationErrors[question.id]}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SelectType;
